import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteMasterSlice = createSlice({
  name: 'DeleteOwner',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteOwner: (state, _) => {
      state.isLoading = true;
    },
    successDeleteOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteOwner: (state) => {
      state.data = {};
    },
  },
});

export const {
  successDeleteOwner,
  failureDeleteOwner,
  deleteOwner,
  clearDeleteOwner,
} = DeleteMasterSlice.actions;

export default DeleteMasterSlice.reducer;
